<div class="partner-account-container">
    <div class="partner-account-content">
        <div class="partner-account-header">
            <div class="account-header-image">
                <img class="logo" [src]="'https:' + sponsorOnboardingCMSData?.accountDetailsIcon.fields.file.url" alt="account-icon">
            </div>
            <div class="account-header-details">
                <div class="header-title">
                    {{sponsorOnboardingCMSData?.accountDetailsLabel}}
                </div>
                <div class="header-desc">
                    {{sponsorOnboardingCMSData?.accountDetailsDesc}}
                </div>
            </div>
        </div>

        <div class="account-field-container">
            <div class="account-fields-primary">
                <app-custom-select-dropdown [fieldTitle]="getGenericLabels?.Title" [required]="true" [width]="100" [widthUnit]="'%'"
                    [options]="salutationTypeList" (valueChange)="valueChange($event, 'title')"
                    [value]="partnerAccDetails.title">
                </app-custom-select-dropdown>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.FirstName" [width]="100" [widthUnit]="'%'" [required]="true"
                    [value]="partnerAccDetails.firstName" (valueChange)="partnerAccValueChange($event, 'firstName')">
                </app-custom-text-field>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.LastName" [width]="100" [widthUnit]="'%'" [required]="true"
                    [value]="partnerAccDetails.lastName" (valueChange)="partnerAccValueChange($event, 'lastName')">
                </app-custom-text-field>
            </div>

            <div class="account-fields-secondary">
                <app-custom-text-field [type]="'email'" [fieldTitle]="getGenericLabels?.Email" [width]="100" [widthUnit]="'%'"
                    [required]="true" [value]="partnerAccDetails.email"
                    (valueChange)="partnerAccValueChange($event, 'email')"
                    [toolTipMessage]="validEmailMsg" [showError]="!isValidEmail">
                </app-custom-text-field>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.Phone" [width]="100" [widthUnit]="'%'" [required]="true"
                    [value]="partnerAccDetails.phone" (valueChange)="partnerAccValueChange($event, 'phone')">
                </app-custom-text-field>
            </div>

            <div class="account-fields-primary">
                <div class="password-container">
                    <app-custom-text-field [fieldTitle]="getGenericLabels?.Password" [width]="100" [widthUnit]="'%'" [required]="true"
                    [value]="partnerAccDetails.password" (valueChange)="partnerAccValueChange($event, 'password')"
                    [type]="inputNewType" [suffixIcon]="newIconUrl" [iconHeight]="'16px'"
                    (iconClicked)="toggleNewPasswordVisibility()" [toolTipMessage]="' '"
                    [focusBorderToolTip]="focusBorderToolTip" (focus)="showPasswordRulesToolTip = true" (blur)="showPasswordRulesToolTip = false">
                </app-custom-text-field>

                <!-- Password helper Tooltip section start -->
                <div class="password-rules-tooltip" id="rulesToolTip"
                    *ngIf="showPasswordRulesToolTip">
                    <div class="arrow_box"></div>
                    <div class="content">
                        <ul>
                            <li>
                                <span class="checkmark"
                                    [ngClass]="{ selected: characterlengthcase }">&nbsp;</span><span>
                                        {{getGenericLabels?.passwordLengthHint}}</span>
                            </li>
                            <li>
                                <span class="checkmark" [ngClass]="{ selected: lowercase }">&nbsp;</span><span>
                                    {{getGenericLabels?.passwordLowercaseHint}}</span>
                            </li>
                            <li>
                                <span class="checkmark" [ngClass]="{ selected: uppercase }">&nbsp;</span><span>
                                    {{getGenericLabels?.passwordUppercaseHint}}</span>
                            </li>
                            <li>
                                <span class="checkmark" [ngClass]="{ selected: numbercase }">&nbsp;</span><span>
                                    {{getGenericLabels?.passwordNumbercaseHint}}</span>
                            </li>
                            <li>
                                <span class="checkmark" [ngClass]="{ selected: specialcase }">&nbsp;</span><span>
                                    {{getGenericLabels?.passwordSpecialHint}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Password helper Tooltip section end -->
                </div>


                <app-custom-text-field [fieldTitle]="getGenericLabels?.ConfirmPassword" [width]="100" [widthUnit]="'%'"
                    [required]="true" [value]="partnerAccDetails.confirmPassword"
                    (valueChange)="partnerAccValueChange($event, 'confirmPassword')" [type]="inputConfirmType"
                    [suffixIcon]="confirmIconUrl" [iconHeight]="'16px'"
                    (iconClicked)="toggleConfirmPasswordVisibility()" [toolTipMessage]="passNotMatchMsg"
                    [showError]="!showPassNotMatchError">
                </app-custom-text-field>

                <!-- <app-custom-select-dropdown [fieldTitle]="'Communication Channel'" [required]="true" [width]="100" [widthUnit]="'%'" [options]="commChannelList"
                (valueChange)="valueChange($event, 'communicationChannel')" [value]="partnerAccDetails.communicationChannel">
                </app-custom-select-dropdown> -->

                <app-multi-select-dropdown [fieldTitle]="getGenericLabels?.CommunicationChannel" [required]="true" [width]="100"
                    [widthUnit]="'%'" [options]="commChannelList"
                    (valueChange)="valueChange($event, 'communicationChannel')"
                    [value]="partnerAccDetails.communicationChannel">
                </app-multi-select-dropdown>
            </div>

            <div class="divider"></div>
        </div>
    </div>
</div>